<div *ngIf="isEndpointTable">
  <div *ngFor="let tableSection of tableSections" class="CommonTable EqualColumn ScrollForTable-sm">
    <h4>{{ tableSection.title }}</h4>
    <div class="body-table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>

<div *ngIf="isInterfaceDesign">
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <div *ngIf="tableSection.heading">{{ tableSection.heading }}</div>
    <div class="body-table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
    <div *ngIf="tableSection.body" [innerHTML]="tableSection.body | mdToHtml"></div>
    <app-api-reference-note-section *ngIf="tableSection.noteSections?.length" [noteSections]="tableSection.noteSections || []"></app-api-reference-note-section>
  </div>
</div>

<div *ngIf="isApiReference">
  <div *ngFor="let tableSection of tableSections" class="CommonTable EqualColumn">
    <h3>{{ tableSection.title }}</h3>
    <div class="body-table boxShadow" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
